export enum IdleStateType {
    ACTIVE,
    PENDING
}
